import React from 'react';
import { Link } from "react-router-dom";

const ProjectCard = (props) => {
   return (
      <Link to={`/projects/${props.project.name}`} state={{ project: props.project }}>
         <div className="projects-project-card">
            <img src={props.project.image}></img>
            <div className="projects-project-card-textsection">
               <h3>{props.project.title}</h3>
               <p>{props.project.description}</p>
               <div className="projects-project-card-tags">
                  {props.project.tags.map(tag => { return <p>{tag}</p> })}
               </div>
            </div>
         </div>
      </Link>
   );
}

export default ProjectCard;